<backdrop-container>
  <regular-popup *ngIf="visible"
                 [title]="strings.Confirm"
                 [showFooter]="true"
                 [closeOnOk]="true"
                 [okButtonText]="strings.Yes"
                 [cancelButtonText]="strings.Cancel"
                 (okClick)="okClick()">
    <div class="p-4" card-type="body">
      <p class="text-center">{{this.message}}</p>
      <mat-calendar [startAt]="dateToday"
                    [(selected)]="selectedDate"
                    [minDate]="dateToday">
      </mat-calendar>
    </div>
  </regular-popup>
</backdrop-container>